import styled from '@emotion/styled';

export const HeaderWrapper = styled.header`
  height: 80px;
  padding: 20px 0;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  background: radial-gradient(
    circle,
    rgba(56, 161, 105, 0.7175245098039216) 0%,
    rgba(198, 235, 215, 0.3925945378151261) 100%
  );
`;
export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
`;
export const Button = styled.p`
  padding: 10px 20px;
  border: 1px solid #38a169;
  border-radius: 0.3em;
  font-weight: 600;
  color: #246743;
  background-color: #fff;
`;
